
export let drugReferenceNDCsDto = {
    brandId: '',
    ndC11: '',
    ndcPackageCode: '',
    ndC9: '',
    productNDC: '',
    ndcDescription: '',
    dosageFormName: '',
}

export let drugReferenceDto = {
    brand: '',
    generic: '',
    comment: '',
    iRxEligible: false,
    startDate: null,
    endDate: null,
    shortDuration: false,
    retailEligible: false,
    retailFee: 0
}